export default __webpack_public_path__ + "static/media/speed-active-m.552cc37a.svg";